import { jobListingSection } from '@stereoagency/sanity-schema';
import { $globalSanityClient } from '@/sanity';
import { jobsQuery } from './jobsQuery';
import UIJobListingSection from './JobListingSection.client';

type Props = typeof jobListingSection.schema.jobListingSection;

export default async function JobListingSection({
  enableTaxonomyFilter
}: Props) {
  const [jobs] = await Promise.all([
    $globalSanityClient.fetch<(typeof jobsQuery)[1]>(jobsQuery[0])
  ]);

  return (
    <UIJobListingSection
      enableTaxonomyFilter={enableTaxonomyFilter}
      jobs={jobs}
    />
  );
}
